/* Tool Armor – new site behaviour */
(function () {
  var COLOURS = {
    'blue': '#1F6FD1', 'bright pink': '#FF4FA3', 'pink': '#FF4FA3', 'green': '#2E9D4F', 'black': '#2B2B2B',
    'red/black': 'linear-gradient(135deg,#C8102E 50%,#1E1E1E 50%)', 'red': '#C8102E', 'gray': '#8A8F96', 'grey': '#8A8F96',
    'blue gray': '#5E7389', 'black & purple': 'linear-gradient(135deg,#6B2FB3 50%,#1E1E1E 50%)'
  };
  function swatchBg(name) { return COLOURS[String(name || '').toLowerCase()] || '#777777'; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function money(cents, format) {
    var f = format || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/<[^>]*>/g, '');
  }

  function initBuy(root) {
    var jsonEl = root.querySelector('[data-ta-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var state = { model: data.start, pack: 0, slots: [], thumb: null };
    function $(sel) { return root.querySelector(sel); }
    function model() { return data.models[state.model]; }
    function avail() { return model().variants.filter(function (v) { return v.available; }); }
    function variant(id) { return model().variants.filter(function (v) { return v.id === id; })[0]; }
    function packs() {
      return [
        { n: 1, pct: 0, label: 'Single case', sub: 'One tool covered', badge: '' },
        { n: data.t1q, pct: data.t1p, label: (data.t1q === 2 ? 'Double' : 'Kit pack') + ' · ' + data.t1q + ' cases', sub: 'Mix colours · save ' + data.t1p + '%', badge: 'SAVE ' + data.t1p + '%' },
        { n: data.t2q, pct: data.t2p, label: 'Crew pack · ' + data.t2q + ' cases', sub: (data.t2q === 5 && data.t2p === 20) ? '5 for the price of 4' : 'Mix colours · save ' + data.t2p + '%', badge: 'BEST VALUE' }
      ];
    }
    function packTotal(p) { return Math.round(model().price * p.n * (100 - p.pct) / 100); }
    function buildSlots(n) {
      var av = avail(); if (!av.length) return [];
      var ids = av.map(function (v) { return v.id; });
      var start = Math.max(0, ids.indexOf(state.slots[0]));
      var out = [];
      for (var k = 0; k < n; k++) {
        if (k < state.slots.length && ids.indexOf(state.slots[k]) > -1) out.push(state.slots[k]);
        else out.push(ids[(start + k) % ids.length]);
      }
      return out;
    }

    function render() {
      var m = model(), ps = packs(), p = ps[state.pack], total = packTotal(p);
      root.querySelectorAll('[data-model]').forEach(function (b) {
        var on = b.getAttribute('data-model') === state.model;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-thumbs]').forEach(function (t) { t.hidden = t.getAttribute('data-thumbs') !== state.model; });

      $('[data-packs]').innerHTML = ps.map(function (pk, i) {
        var t = packTotal(pk), full = m.price * pk.n;
        return '<button type="button" class="ta-pack' + (i === state.pack ? ' is-on' : '') + '" data-pack="' + i + '" aria-pressed="' + (i === state.pack) + '">' +
          '<span class="ta-pack__radio"></span>' +
          '<span class="ta-pack__main"><span class="ta-pack__label">' + esc(pk.label) + '</span><span class="ta-pack__sub">' + esc(pk.sub) + '</span></span>' +
          '<span class="ta-pack__price"><span class="ta-pack__total">' + esc(money(t, data.format)) + '</span>' +
          (pk.pct ? '<span class="ta-pack__was">' + esc(money(full, data.format)) + '</span>' : '') +
          '<span class="ta-pack__each">' + (pk.n > 1 ? esc(money(Math.round(t / pk.n), data.format)) + ' each' : esc(data.currency)) + '</span></span>' +
          (pk.badge ? '<span class="ta-pack__badge">' + esc(pk.badge) + '</span>' : '') + '</button>';
      }).join('');

      var av = avail();
      $('[data-slots]').innerHTML = state.slots.map(function (id, k) {
        var v = variant(id);
        return '<div class="ta-slot"><span class="ta-slot__label"><small>' + (p.n > 1 ? 'CASE ' + (k + 1) : 'COLOUR') + '</small><b>' + esc(v ? v.color : '') + '</b></span>' +
          '<span class="ta-swatches">' + av.map(function (a) {
            return '<button type="button" class="ta-swatch' + (a.id === id ? ' is-on' : '') + '" data-slot="' + k + '" data-variant="' + a.id + '" aria-label="' + esc(a.color) + '" aria-pressed="' + (a.id === id) + '" style="background:' + swatchBg(a.color) + '"></button>';
          }).join('') + '</span></div>';
      }).join('');

      var first = variant(state.slots[0]);
      var img = $('[data-main-img]');
      var src = state.thumb || (first && first.image) || m.image;
      if (img && src && img.getAttribute('src') !== src) { img.setAttribute('src', src); img.removeAttribute('srcset'); }
      if (img && first) img.setAttribute('alt', m.name + ' case in ' + first.color);
      var tag = $('[data-main-tag]'); if (tag && first) tag.textContent = first.color + ' · ' + m.name;

      var ship = $('[data-ship]');
      if (ship) {
        if (data.au) {
          var free = total >= data.threshold;
          ship.hidden = false;
          $('[data-ship-msg]').textContent = free ? 'Free Australian shipping included' : 'Add ' + money(data.threshold - total, data.format) + ' more for free AU shipping';
          $('[data-ship-bar]').style.width = Math.min(100, Math.round(total / data.threshold * 100)) + '%';
        } else { ship.hidden = true; }
      }
      var label = 'Add to cart — ' + money(total, data.format);
      $('[data-atc]').textContent = label;
      $('[data-dots]').innerHTML = state.slots.map(function (id) { var v = variant(id); return '<span class="ta-dot" style="background:' + swatchBg(v && v.color) + '"></span>'; }).join('');
      var st = document.querySelector('[data-sticky]');
      if (st) {
        st.querySelector('[data-sticky-sub]').textContent = m.name + ' · ' + (p.n === 1 ? (first ? first.color : '') : p.n + ' cases');
        st.querySelector('[data-sticky-total]').textContent = money(total, data.format);
      }
      $('[data-atc]').disabled = !state.slots.length;
    }

    function setModel(key) {
      if (!data.models[key]) return;
      state.model = key; state.thumb = null;
      var n = packs()[state.pack].n; state.slots = []; state.slots = buildSlots(n); render();
    }

    function add(btn) {
      var err = $('[data-error]'); err.hidden = true;
      var counts = {};
      state.slots.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      if (!items.length) return;
      var buttons = [$('[data-atc]')].concat(Array.prototype.slice.call(document.querySelectorAll('[data-sticky-add]')));
      buttons.forEach(function (b) { b.disabled = true; });
      var old = btn.textContent; btn.textContent = 'Adding…';
      fetch(data.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { window.location.href = data.cartUrl; })
        .catch(function () {
          err.textContent = 'That didn’t go through — one of those colours may have just sold out. Try another colour or refresh.';
          err.hidden = false; btn.textContent = old; buttons.forEach(function (b) { b.disabled = false; });
        });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-model')) { setModel(t.getAttribute('data-model')); return; }
      if (t.hasAttribute('data-pack')) { state.pack = parseInt(t.getAttribute('data-pack'), 10); state.slots = buildSlots(packs()[state.pack].n); render(); return; }
      if (t.hasAttribute('data-slot')) { state.slots[parseInt(t.getAttribute('data-slot'), 10)] = parseInt(t.getAttribute('data-variant'), 10); if (t.getAttribute('data-slot') === '0') state.thumb = null; render(); return; }
      if (t.hasAttribute('data-thumb')) {
        state.thumb = t.getAttribute('data-full');
        t.parentNode.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
        render(); return;
      }
      if (t.hasAttribute('data-atc')) { add(t); }
    });
    document.querySelectorAll('[data-sticky-add]').forEach(function (b) { b.addEventListener('click', function () { add(b); }); });

    var atc = $('[data-atc]'), sticky = document.querySelector('[data-sticky]');
    if (atc && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-show', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(atc);
    }

    state.slots = buildSlots(1);
    render();
  }

  function initVote(form) {
    var tags = form.querySelector('[data-vote-tags]');
    form.addEventListener('change', function (e) {
      if (e.target.name === 'ta-vote' && tags) tags.value = 'newsletter, next-tool-vote, vote-' + e.target.value;
    });
  }

  function boot() {
    document.querySelectorAll('[data-ta-buy]').forEach(initBuy);
    document.querySelectorAll('#ta-vote-form').forEach(initVote);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
